import type { FaireProductEntity } from "../../entity_types/product";

export const p_p6rp8pe965: FaireProductEntity = {
  token: "p_p6rp8pe965",
  type: "product",
  name: "Beaded Evil Eye Coin Purse",
  brandToken: "b_4ahkhhvtpz",
  brandName: "Collections by Fame Accessories",
  imageUrl:
    "https://cdn.faire.com/fastly/c0a043926e5b34b38a808bc738f28cb0c0d79a5333de5436e2dceab5ef8663c7.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/78544d838c7e271e87d19f3afa96ac56c7de01e6155c751228772530a723b6fd.jpeg",
  ],
  priceDollars: 10.05,
  description:
    "This bag introduces a unique beaded evil eye coin purse style. Elevate your ensemble with this chic, timeless bag.\n\nThis bag approximately measures (Inches):\nL: 5\nH: 4",
  tags: [],
  msrpDollars: 29.09,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:58:26.269Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
